export default "__VITE_ASSET__8102227f__"